<template>
  <div class="header-right">
    <dx-toolbar class="header-top">
      <dx-item>
        <slot></slot>
      </dx-item>
    </dx-toolbar>
    <dx-toolbar class="header-bottom" v-if="showTabs">
      <dx-item
        location="before"
        widget="dxTabs"
        :selected-index.sync="selectedIndex"
        :options="options"
      ></dx-item>
    </dx-toolbar>
  </div>
</template>

<script>
export default {
  props: ["options", "selectedIndex", "showTabs"],
  data() {
    return {};
  },
  components: {},
};
</script>

<style lang="scss">
.header-right {
  display: flex;
  flex-direction: column;

  .header-top {
    margin-bottom: 10px;
    .dx-toolbar-items-container {
      height: auto;
    }
  }

  .header-bottom {
    margin-bottom: 15px;
    padding-bottom: 5px;
    .dx-toolbar-items-container {
      height: auto;
    }
  }
}
</style>
